import { UI } from '@genial/components';
import { BoxRadius, Spacing } from '@genial/design-tokens';
import { Pressable, HStack } from 'native-base';
import React from 'react';

import {
  TableContent,
  TableContentItemColumn,
  TableContentItemText,
} from '../../../../../../../../../components/TableContent';
import { LateralBar } from '../../../../../../../../BatchTicket/components/DynamicAsset/components/Asset/components/LateralBar';
import { usePublicOfferAssetContext } from '../../../../../../../../BatchTicket/components/DynamicAsset/contexts/products/PublicOffer';
import { useGlobalProductContext } from '../../../../../contexts';
import { availableProductPublicOfferConstant } from '../constants';

import { PublicOfferItemTypes } from '.';

export const PublicOfferItemDesktop: React.FC<PublicOfferItemTypes.Props> = ({ offer }) => {
  const { setModalOpen, setOfferSelected } = usePublicOfferAssetContext();
  const { product } = useGlobalProductContext();

  const onOpenDetailsModal = () => {
    setModalOpen(true);
    setOfferSelected(offer);
  };

  const getFlex = (index: number) => {
    const currentHead = availableProductPublicOfferConstant.tableHead.find((_, i) => i === index);
    return currentHead?.flex || 1;
  };

  return (
    <TableContent direction="row" space={0} p={0} px={Spacing['inline.xxxs']} h="80px">
      <LateralBar
        backgroundColor={product.color}
        borderTopLeftRadius={BoxRadius.sm}
        borderBottomLeftRadius={BoxRadius.sm}
      />
      <TableContentItemColumn flex={getFlex(0)}>
        <HStack alignItems="center" space={Spacing['inline.xxxs']}>
          <UI.Tooltip testID="details-tooltip" label="Ver detalhes">
            <Pressable onPress={onOpenDetailsModal}>
              <UI.Icon name="Info" size="xs" />
            </Pressable>
          </UI.Tooltip>
          <TableContentItemText>{offer.offerType}</TableContentItemText>
        </HStack>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(1)} pr={Spacing['inline.xxxs']}>
        <TableContentItemText>{offer.offerName}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(2)}>
        <TableContentItemText>{offer.isinCode}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(3)}>
        <TableContentItemText>{offer.alterationDateFormatted}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(4)}>
        <TableContentItemText>{offer.negotiationDateFormatted}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(5)}>
        <TableContentItemText>{offer.liquidityDateFormatted}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(6)}>
        <TableContentItemText>{offer.suitabilityProfile}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(7)}>
        <TableContentItemText>{offer.rateLimiterTranslated}</TableContentItemText>
      </TableContentItemColumn>
    </TableContent>
  );
};
